import Axios from "axios";
import {getHost} from "./ApiRequest";

const getTokens = () => {
    return Axios.get(getHost() + "/info/tokens", null).then(response => {
        return Promise.resolve(response.data);
    });
};

export {getTokens};